// extracted by mini-css-extract-plugin
export default {"xxsmall":"375px","xsmall":"480px","small":"750px","medium":"1100px","large":"1350px","xlarge":"1650px","xxlarge":"2000px"};